var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h3',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.pageTitle))])]),_vm._v(" "),_c('div',{staticClass:"col-auto text-right"},[_vm._t("pageHeaderActions")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e4cee88","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/PageHeader.vue
// module id = null
// module chunks = 